module.exports = __webpack_public_path__ + "img/clockSimplePlus.7b615b53.svg";